export const meta = {
  title: 'Staff & roles: the right buttons for the right hands',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'billing'],
};

Your whole crew can use the dashboard — but a washer doesn't need your billing page, and your cashier doesn't need to edit the catalog. Four roles keep that tidy. Manage them on the **Staff** page, which itself is visible to owners and managers only.

## The four roles

- **Owner** — full access: billing, staff, every screen. This is you: the role is set at signup and can't be handed out or edited on the Staff page.
- **Manager** — the trusted deputy: settings, catalog, reports, queue reordering, voucher issuing, staff management. Practically everything except being the owner.
- **Cashier** — the counter: take payments at the POS, create and advance tickets, look up customers, read reports. No reordering the queue, no money settings, no staff management.
- **Washer** — the wash bay: the queue board only — advancing tickets through their statuses. Washers can't reorder the line (a per-outlet switch to allow it exists under the hood, but its dashboard toggle isn't built yet). No POS.

Behind the scenes, every role is enforced at the data layer — someone poking at a URL beyond their role gets refused by the server, not just hidden buttons.

## Inviting someone

On the Staff page, the invite card takes three things: their **Malaysian mobile number** (required), an optional display name, and a role — **Manager**, **Cashier**, or **Washer**, with Cashier pre-selected.

That's the whole flow. There's no email, no invite link, and nothing to accept: submitting attaches the role immediately. If the phone number is new, an account is created on the spot — the person just signs in with a one-time code (OTP) to their phone the first time. If they already use the platform with that number, the role simply applies the next time they refresh.

## Staff belong to an outlet

Invites go to the outlet you're currently viewing — check the outlet switcher before you submit. Someone working across two outlets? Invite the same phone number at each one.

## Changing roles and letting people go

Each staff row has a role dropdown — change it and it takes effect at their next refresh. **Deactivate** removes someone's access while keeping their record (who added them, when) for your books; **Reactivate** brings them back. Two rows are locked on purpose: the owner's, and your own — so nobody accidentally locks themselves out of their own carwash.

## What staffing doesn't include yet

No seat limits — invite as many staff as your operation needs at no extra charge. Also not built yet, so you don't go looking: PIN-based fast login for shared tablets, shift scheduling, and clock-in tracking. Staff sign in with their phone OTP, and the roles above are the entire permission model.
